import { SxType } from "../types";

export const zoomSx = (hovered: boolean): SxType => ({
    transition: "transform 0.3s",
    transform: hovered ? "scale(1.1)" : undefined
});

export const cardDropSx = (hovered: boolean, hoverAmount = 5): SxType => ({
    transition: "transform 0.3s",
    transform: hovered ? `translateY(-${hoverAmount}px)` : undefined
});

export const verticalScroll = (height: string): SxType => ({
    overflow: "scroll",
    maxHeight: height,
    minHeight: "fit-content",
    ...hideScrollbarSx
});

export const hideScrollbarSx = {
    "::-webkit-scrollbar ": { display: "none" },
    scrollbarWidth: "none"
};

export const gradientScrollSx: SxType = {
    overflowX: "auto",
    overflowY: "hidden",
    width: "100%",
    height: "100%",
    maskImage: "linear-gradient(to right, black 85%, transparent 100%)",
    WebkitMaskImage: "linear-gradient(to right, black 85%, transparent 100%)",
    scrollbarWidth: "none", // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Chrome, Safari, Edge
    },
    msOverflowStyle: "none" // IE and Edge
};

export const hiddenScrollSx: SxType = {
    overflowX: "auto",
    overflowY: "hidden",
    width: "100%",
    height: "100%",
    scrollbarWidth: "none", // Firefox
    "&::-webkit-scrollbar": {
        display: "none" // Chrome, Safari, Edge
    },
    msOverflowStyle: "none", // IE and Edge
    scrollBehavior: "smooth"
};

export const filterButtonRippleSx: SxType = {
    transition: "background-size 0.4s",
    backgroundSize: "15000%"
};
